import { render, staticRenderFns } from "./EditarEmitirSunat.vue?vue&type=template&id=2bc258e2"
import script from "./EditarEmitirSunat.vue?vue&type=script&lang=js"
export * from "./EditarEmitirSunat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports